<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaldedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md12>
        <v-flex xs12 md12>
          <v-switch
              v-model="priceIncrease.isAllProduct"
              @change="changeAllProduct"
              :label="`Ürünlerin Hepsini Seç: ${setState(priceIncrease.isAllProduct)}`"
          ></v-switch>
        </v-flex>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field
          v-model="priceIncrease.price"
          label="Eklencek TL Miktarı"
          :counter="max"
          required
        ></v-text-field>
      </v-flex>

      <v-flex xs12 md12>
        <v-combobox
            v-model="select"
            :items="this.$store.getters['products/productCategories']"
            item-value="id"
            multiple
            @change="changeProduct"
            item-text="name"
            hide-details
            label="Ürün Seçiniz"
        ></v-combobox>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="priceIncrease.startDate"
              label="Başlangıç Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="priceIncrease.startDate"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          ref="menu3"
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="priceIncrease.startTime"
              label="Başlangıç Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu3"
            v-model="priceIncrease.startTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu3.save(time)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="priceIncrease.endDate"
              label="Bitiş Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="priceIncrease.endDate"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          ref="menu4"
          v-model="menu4"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="priceIncrease.endTime"
              label="Bitiş Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu4"
            v-model="priceIncrease.endTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu4.save(time)"
          ></v-time-picker>
        </v-menu>
      </v-flex>

      <v-flex xs12 md12>
        <v-switch
          v-model="priceIncrease.state"
          :label="`Doviz Durumu: ${setState(priceIncrease.state)}`"
        ></v-switch>
      </v-flex>
      <v-btn color="success" @click="savepriceIncrease">Kaydet</v-btn>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    products: [],
    alert: false,
    allowSpaces: false,
    match: "Foobar",
    max: 0,
    select: [],
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    menu1: false,
    time: null,
    menu2: false,
    menu3: false,
    menu4: false,
    model: "Foobar",
    priceIncrease: {
      state: true,
    },
  }),

  watch: {},

  methods: {
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    changeAllProduct(categoryids) {
      if (categoryids) {
        this.select = this.$store.getters["products/productCategories"];
      } else {
        this.select = [];
      }
    },
    changeProduct() {
    },
    async savepriceIncrease() {
      this.priceIncrease.price = this.priceIncrease.price;
      let priceIncrease = Object.assign({}, this.priceIncrease);
      priceIncrease.productIds = this.select.map((m) => m.id).join(",");

      if (this.priceIncrease.id)
        this.$store.dispatch("priceIncrease/putPriceIncrease", priceIncrease);
      else
        this.$store.dispatch("priceIncrease/postPriceIncrease", priceIncrease);
      this.alert = true;
    },
    validateField() {
      this.$refs.form.validate();
    },
    resetValidation() {
      //   this.$refs.form.validate();
    },
  },
  computed: {},
  async mounted() {
    await this.$store.dispatch("products/getProductsByMpProducts");
    
    if (this.$route.params.id) {
      await this.$store.dispatch(
        "priceIncrease/getPriceIncrease",
        this.$route.params.id
      );
      this.priceIncrease = this.$store.state.priceIncrease.priceIncrease;
      this.priceIncrease.startDate = this.priceIncrease.startDate.substr(0, 10);
      this.priceIncrease.endDate = this.priceIncrease.endDate.substr(0, 10);
      this.priceIncrease.startTime = this.priceIncrease.startTime.substr(0, 5);
      this.priceIncrease.endTime = this.priceIncrease.endTime.substr(0, 5);
      if (this.priceIncrease.productIds) {
        var ids = this.priceIncrease.productIds.split(",").map(Number);
        this.select = this.$store.getters["products/productCategories"].filter(
            (x) => ids.includes(x.id)
        );
      }
    }
  },
};
</script>
